import { createApi } from '@/api/modules/utils'

const baseUrl = '/material/image/detail'
const api = createApi(baseUrl)

// 用户相关API
export const materialImageDetailApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'post'),
  tags: api('tags', 'get'),
  tag: api('tag', 'post'),
  search: api('search', 'get'),
  select: api('select', 'get'),
  generate: api('generate', 'post'),
  generateFind: api('generate/find', 'get'),
  removeTag: api('remove_tag', 'post'),
}